import { Box, Flex, Image, Link, Text, getPaletteColor } from 'pcln-design-system'
import { Check, Phone } from 'pcln-icons'
import React, { useEffect } from 'react'
import styled from 'styled-components'

import { logNoResults } from '@mfs/client/common/log-ga-event'
import { logEvent } from '@mfs/client/common/log-ga-event/logGaEvent'

const ErrorScreen = styled.div`
  display: flex;
  margin: ${(props) => (props.removeTopMargin ? '0 0 120px;' : '30px 0 120px;')};
  text-align: center;
  flex-direction: column;
  cursor: default;
`

const PhoneLink = styled.a`
  text-decoration: none;
  color: ${getPaletteColor('primary.base')};
`

const TextBox = styled.div`
  height: 48px;
  line-height: 1.33;
  margin-bottom: 24px;

  .fly-error-screen__text {
    &.mobile-version {
      ${(props) => props.theme.mediaQueries.lg} {
        display: none;
      }
    }

    &.not-mobile-version {
      ${(props) => props.theme.mediaQueries.xs} {
        display: none;
      }
      ${(props) => props.theme.mediaQueries.lg} {
        display: inline;
      }
    }
  }
`

const StyledImage = styled(Image)`
  margin-left: auto;
  margin-right: auto;
`

const SmartTipsList = styled.ul`
  text-align: left;
`

const SmartTipsText = styled.li`
  display: inline-block;
  margin-bottom: 12px;
`

const StyledLink = styled(Link)`
  text-decoration: none;
`

const SearchErrorScreen = ({
  forceHeaderOpen,
  isMobile,
  isPackageListings,
  isReshopExperience,
  phoneBookNumber,
  showPhoneNumber,
  urlParams,
}) => {
  useEffect(() => {
    if (urlParams) {
      logNoResults({ isReshopExperience, urlParams })
    }
  }, [isReshopExperience, urlParams])

  useEffect(() => {
    if (isPackageListings) {
      logEvent('display', {
        type: 'flight_listings_error',
        page_name: 'pkg_flight_listings',
        product_name: 'bundle',
      })
    }
  }, [isPackageListings])

  const textMobile = (
    <Text className='fly-error-screen__text mobile-version' fontSize={2} color='text.light'>
      <StyledLink onClick={forceHeaderOpen}>Update your choices</StyledLink> so we can try again!
    </Text>
  )
  const textNotMobile = (
    <Text className='fly-error-screen__text not-mobile-version' fontSize={2} color='text.light'>
      Update your choices so we can try again.
    </Text>
  )

  const tips = [
    'Select new airports',
    'Change your dates',
    ...(!isReshopExperience ? ['Confirm the number of travelers'] : []),
    ...(showPhoneNumber ? ['Call us to book with an agent'] : []),
  ]

  return (
    <ErrorScreen removeTopMargin={phoneBookNumber && isMobile}>
      <section className='fly-error-screen-section'>
        <Text fontSize={4} color='text.light' mb={2}>
          Oh no!
        </Text>
        <TextBox>
          {phoneBookNumber && isMobile ? (
            <Text px={1} className='fly-error-screen__text mobile-version' fontSize={2} color='text.light'>
              We can&apos;t find any flights that match your search.{' '}
              <StyledLink onClick={forceHeaderOpen}>Update your choices</StyledLink> so we can try again!
            </Text>
          ) : null}
          {(phoneBookNumber && !isMobile) || !phoneBookNumber ? (
            <Text color='text.light' fontSize={2}>
              We can&apos;t find any flights that match your search.
            </Text>
          ) : null}
          {phoneBookNumber ? null : textMobile}
          {textNotMobile}
        </TextBox>

        <Box mb={4}>
          <StyledImage
            src='https://s1.pclncdn.com/design-assets/fly-images/phoneSalesErrorLogo.svg'
            height={phoneBookNumber ? 185 : 92}
            alt=''
            className='hero-image'
          />
        </Box>
      </section>

      <Flex justifyContent={'center'} mx='auto'>
        <div className='smart-tips-container'>
          <Text fontSize={3} color='border.dark' mb={3} align={'left'}>
            Smart Tips
          </Text>
          <SmartTipsList>
            {tips.map((tip, index) => {
              return (
                <span key={index}>
                  <Check color='primary.base' size={14} />
                  <SmartTipsText>
                    <Text fontSize={2} pl={2} color='border.dark'>
                      {tip}
                    </Text>
                  </SmartTipsText>
                  <br />
                </span>
              )
            })}
            {showPhoneNumber ? (
              <Flex ml={'20px'}>
                <Phone mr={1} size={19} color='primary.base' />
                <Text bold textAlign={['right', 'center']} fontSize={[0, 1]}>
                  <PhoneLink href={`tel: ${phoneBookNumber}`}>{phoneBookNumber}</PhoneLink>
                </Text>
              </Flex>
            ) : null}
          </SmartTipsList>
        </div>
      </Flex>
    </ErrorScreen>
  )
}

export { SearchErrorScreen }
